/* eslint jsx-a11y/no-redundant-roles: 0 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Container, Heading } from '@scentregroup/ui'
import { uniqueId } from 'lodash'
import DeckScrollWrapper from '../deck-scroll-wrapper'
import analyticsUtils from '../../helpers/analytics-utils'
import { CONFIG_KEYS, getClientConfigBool } from '../../helpers/config-helper'
import style from './index.scss'

class FeaturedContent extends Component {
  componentDidMount() {
    const { children } = this.props
    // If there is less than 4 items, the module won't display
    if (
      children &&
      children.length &&
      !getClientConfigBool(CONFIG_KEYS.NEXT_PUBLIC_FEAT_FLAG_MEASUREMENT)
    ) {
      this.trackVisibleItems(children)
    }
  }

  trackVisibleItems = items => {
    const cards = items.map(c => c.props)
    // Minimum acceptable number of Featured content items
    const minRequiredVisibleItems = 4
    const promotions = cards.slice(0, minRequiredVisibleItems).map(i => ({
      id: i.id,
      name: i.title,
      position: analyticsUtils.positions.FEATURED_CONTENT,
      dimension90: analyticsUtils.dimensions.DIMENSION90,
      creative: i.body,
    }))

    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.PROMOTION_IMPRESSION,
      ecommerce: {
        promoView: {
          promotions,
        },
      },
    })
  }

  trackClickEvent = item => {
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.PROMOTION_CLICK,
      ecommerce: {
        promoClick: {
          promotions: {
            id: item.id,
            name: item.title,
            position: analyticsUtils.positions.FEATURED_CONTENT,
            dimension90: analyticsUtils.dimensions.DIMENSION90,
            creative: item.body,
          },
        },
      },
    })
  }

  render() {
    const { children, title, isEvolved = false, padded = false } = this.props
    const id = uniqueId('featured-content-')
    return (
      <Container
        type="full"
        className={classNames(style.deckContainer, {
          [style.evolved]: isEvolved,
        })}
      >
        {title && (
          <Heading
            type={isEvolved ? 'small' : 'megasmalldivider'}
            className={style.heading}
            id={id}
          >
            {title}
          </Heading>
        )}
        <DeckScrollWrapper
          contentClassName={style.featuredContentScroll}
          className={style.contentWrapper}
          useCosmeticScrollbar={false}
          eventCategory={analyticsUtils.categories.WHATS_HAPPENING_FEATURED}
          eventAction={analyticsUtils.actions.CLICK}
          isEvolved={isEvolved}
        >
          <ol className={style.deckCardList} aria-labelledby={id} role="list">
            {React.Children.map(children, child =>
              React.cloneElement(child, {
                className: style.deckCard,
                onClick: () => this.trackClickEvent(child.props),
                isEvolved,
                padded,
              })
            )}
          </ol>
        </DeckScrollWrapper>
      </Container>
    )
  }
}

FeaturedContent.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  isEvolved: PropTypes.bool,
  padded: PropTypes.bool,
}

export default FeaturedContent
